import { queryOptions } from '@tanstack/react-query';

import { SensorTypeCode } from '@/common/asset-sensor';
import { ROLE } from '@/common/role';
import type { TpsSensorPerfStatsChartRecord } from '@/common/sensors/tps/tps-perfstats-chart';
import { usePermission } from '@/hooks/use-permission';
import { checkAssetIdIsValid } from '@/lib/utils/asset';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '@/queries/common';
import { API_URLS } from '@/queries/query.client';

export type TpsSensorPerfStatsChartResponse = {
	chartData: TpsSensorPerfStatsChartRecord[];
	lastPerfStat: TpsSensorPerfStatsChartRecord | null;
};

export type TpsSensorPerfStatsQueryParams = {
	days: number;
};

export async function getTPSPerfStats(
	assetId: string,
	query: TpsSensorPerfStatsQueryParams,
): Promise<TpsSensorPerfStatsChartResponse | null> {
	const response = await axios.get(`${API_URLS.ASSETS.SENSORS.TPS.PERF_STATS(assetId)}`, { params: query });
	return getResponse<TpsSensorPerfStatsChartResponse>(response.data);
}

export const useQueryGetTPSPerfStats = (assetId: string, query: TpsSensorPerfStatsQueryParams, enabled = true) => {
	const shouldRead = usePermission(ROLE.SENSORS_TPS_PERFSTATS_READ);
	const isValidAssetId = checkAssetIdIsValid(assetId);
	return queryOptions({
		queryKey: ['assets', assetId, 'sensors', SensorTypeCode.TPS, 'perfstats', query],
		queryFn: () => getTPSPerfStats(assetId, query),
		enabled: enabled && shouldRead && isValidAssetId,
	});
};
